import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const LocationPinIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M11.984 11.456C12.432 11.456 12.848 11.344 13.232 11.12C13.616 10.896 13.92 10.596 14.144 10.22C14.368 9.844 14.48 9.432 14.48 8.984C14.48 8.536 14.368 8.12 14.144 7.736C13.92 7.352 13.616 7.048 13.232 6.824C12.848 6.6 12.432 6.488 11.984 6.488C11.536 6.488 11.124 6.6 10.748 6.824C10.372 7.048 10.072 7.352 9.848 7.736C9.624 8.12 9.512 8.536 9.512 8.984C9.512 9.672 9.752 10.256 10.232 10.736C10.712 11.216 11.296 11.456 11.984 11.456ZM11.984 2C13.264 2 14.44 2.312 15.512 2.936C16.568 3.56 17.408 4.39999 18.032 5.456C18.656 6.52801 18.968 7.70399 18.968 8.984C18.968 9.96001 18.728 11.08 18.248 12.344C17.832 13.416 17.256 14.576 16.52 15.824C15.912 16.816 15.216 17.848 14.432 18.92C13.888 19.672 13.312 20.408 12.704 21.128L11.984 21.968L11.264 21.128C10.656 20.408 10.08 19.672 9.536 18.92C8.752 17.848 8.056 16.816 7.448 15.824C6.712 14.576 6.136 13.416 5.72 12.344C5.24 11.08 5 9.96001 5 8.984C5 7.70399 5.312 6.52801 5.936 5.456C6.56 4.39999 7.4 3.56 8.456 2.936C9.52801 2.312 10.704 2 11.984 2Z'
                fill='currentColor'
            />
        </>
    ),
})

LocationPinIcon.displayName = 'LocationPinIcon'
